import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CatalogoListado from "../../components/Catalogo";
import * as catalogoActions from "../../reducers/catalogoReducer/actions";
import * as rubroActions from "../../reducers/rubrosReducer/actions";
import { catalogoDataSelector } from "../../selectors/catalogoSelector";
import * as Notification from "../../components/Common/notification";
import { instalacionSelector } from "../../selectors/sessionSelector";
import { articuloDataSelector } from "../../selectors/articuloSelector";
import * as articuloActions from "../../reducers/articuloReducer/actions";

class CatalogoListadoContainer extends React.Component {
  constructor(props) {
    super(props);

    this.props.sagaInitialStateReloadAll(); // Tenemos dos initial state ya que uno mantiene las imagenes, y el otro reinicia todo. Para el listado de catalogos, limpiamos todo.
    let payload = {};
    if (this.props.match.params.idInstalacion !== undefined) {
      payload.nombre = "";
      payload.idInstalacion = this.props.match.params.idInstalacion;
    }
    this.props.sagaGetCatalogoByName(payload);

    this.state = {
      catalogo: {
        id: 0,
        nombre: "",
        descripcion: "",
      },
      catalogosVacios: false,
      update: false,
      imagenesCargadas: false,
      modalConfirmarEliminacion: false,
    };
  }

  componentDidUpdate = () => {
    /* let searchPayload = {}
         searchPayload.search = '';
         searchPayload.idInstalacion = null;
         
         
         if (this.props.instalacion!==undefined)
         {
             searchPayload.idInstalacion=this.props.instalacion.id;
             this.props.sagaGetCatalogoByName(searchPayload);    
         }
     
 */
    if (this.props.data.catalogos !== undefined && this.state.imagenesCargadas === false) {
      this.getImagenesCatalogos();
    }
  };

  //Continuar para mostrar un cartel que muestre la falta de resultados
  UNSAFE_componentWillReceiveProps = (props) => {
    if (props.data.catalogos !== undefined && this.state.imagenesCargadas === true) {
      if (props.data.catalogos.length === 1) {
        //solo un catalogo
        this.setState({
          catalogo: {
            id: this.props.data.catalogos[0].id,
            nombre: this.props.data.catalogos[0].nombre,
          },
          catalogosVacios: false,
          update: false,
          imagenesCargadas: false,
        });
        this.props.history.push("/Catalogo/catalogoEdicion/" + props.data.catalogos[0].idCatalogo);
      }
      if (props.data.catalogos.length === 0 && this.state.update === false) {
        this.setState({
          catalogosVacios: true,
          update: true,
        });
      }
    }

    /*  if (this.props.instalacion!==undefined)
          {
   
               let searchPayload = {}
               searchPayload.search = '';
               searchPayload.idInstalacion = null;
               
               
               if (this.props.instalacion!==undefined && this.props.instalacion!=null)
               {
                   searchPayload.idInstalacion=this.props.instalacion.id;
                   this.props.sagaGetCatalogoByName(searchPayload);    
               }
          }*/
  };
  getImgArticulo = (idArticulo) => {
    let flag = true;

    if (this.props.imagenesArticulos !== undefined) {
      this.props.imagenesArticulos.forEach((img) => {
        if (img.idArticulo === idArticulo) {
          flag = false;
        }
      });
    }
    if (flag) {
      let payload = {};
      payload.idArticulo = idArticulo;
      payload.listaCompleta = false;
      this.props.sagaGetImagenesListadoArticulos(payload);
    }
  };

  handleOnClickEliminarArticulo = () => {
    this.setState({
      modalConfirmarEliminacion: true,
    });
  };

  handleOnClickCancelarEliminarArticulo = () => {
    this.setState({
      modalConfirmarEliminacion: false,
    });
  };
  getImagenesCatalogos = () => {
    for (var i = 0; i < this.props.data.catalogos.length; i++) {
      let catalogo = this.props.data.catalogos[i];

      // sólo busco la imagen si aún no ha sido cargada
      if (catalogo.imagenCatalogo === undefined) {
        let payload = {};
        payload.idCatalogo = catalogo.idCatalogo;
        payload.callback = () =>
          this.setState({
            imagenesCargadas: true,
          });

        this.props.sagaGetImagenCatalogo(payload);
      }
    }
  };

  handleOnChange = (event) => {
    let newCatalogo = { ...this.state.catalogo };
    newCatalogo[event.target.name] = event.target.value;
    this.setState({ catalogo: newCatalogo });
  };

  handleOnDropFile = () => {};

  handleOnSave = () => {
    // armo el payload para guardar el catálogo
    let savePayload = {};
    savePayload.Id = this.state.catalogo.id;
    savePayload.Nombre = this.state.catalogo.nombre;
    savePayload.Descripcion = this.state.catalogo.descripcion;

    this.props.sagaSaveCatalogo(savePayload);
  };

  handleOnSearch = (searchString) => {
    if (searchString.length < 255) {
      let searchPayload = {};
      searchPayload.search = searchString;
      searchPayload.idInstalacion = null;

      if (this.props.instalacion !== undefined)
        searchPayload.idInstalacion = this.props.instalacion.id;
      this.props.sagaGetCatalogoByName(searchPayload);
    } else Notification.showError("Exceso de caracteres. Revise la búsqueda.");
  };

  handleOnCloseVacios = () => {
    this.setState({
      catalogosVacios: false,
      update: false,
    });
  };
  UNSAFE_componentWillMount() {}
  render() {
    return (
      <CatalogoListado
        catalogos={this.props.data.catalogos}
        instalacion={this.props.instalacion}
        handleOnChange={this.handleOnChange}
        handleOnDropFile={this.handleOnDropFile}
        handleOnSave={this.handleOnSave}
        handleOnSearch={this.handleOnSearch}
        catalogosVacios={this.state.catalogosVacios}
        handleOnCloseVacios={this.handleOnCloseVacios}
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...catalogoActions,
      ...rubroActions,
      ...articuloActions,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    instalacion: instalacionSelector(state),
    data: catalogoDataSelector(state),
    dataArticulos: articuloDataSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogoListadoContainer);
